import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {

  loadHome (context) {

    context.commit('addLog', { request:'Home' })
    return new Promise((resolve, reject) => {
      Vue.axios.get(CONFIG.getEndpoint('home'),{
        withCredentials: true,
        xsrfCookieName: 'SSO_TOKEN'
      }).then((response) => {
        context.commit('INIT_APP', response.data)
        // context.commit('hideLoader')
        context.commit('removeLog', { request:'Home' })
        resolve()
      }).catch(()=>{
        // context.commit('hideLoader')
        context.commit('removeLog', { request:'Home' })
        reject()
      })

   })

  }

}

export default actions



// WEBPACK FOOTER //
// ./src/store/home/actions.js